module.exports = __webpack_public_path__ + "img/qualiticien-micro-CD_042.fd87c508.jpg";